import Sveip from '@nrk/dh-basis-sveip'

import './infosveip.module.css'
import './infosveip.template-adjustments.module.css'
import './info.module.css'
import './themes.module.css'

export default class Infosveip extends Sveip {
  connectedCallback() {
    super.connectedCallback()
  }
}
